<template>
  <div class="custom-input flex flex-wrap field-option">
    <label style="padding-top: 12px;">
      <input type="checkbox"
             v-model="value"
             ref="Name"
             name="Name"
             data-vv-name="Input Name"
             v-validate="'required'"
      >
      <span class="text-danger text-sm" v-show="errors.has('Name')">{{ errors.first('Name') }}</span>
    </label>
    <label style="padding-top: 12px;">
      <input type="text" class="px-4" v-model="name" placeholder="Input Name" />
    </label>
    <div class="flex flex-wrap">
      <select v-model="code" class="flex-1 px-4 al-select">
        <option v-for="(field, index) in fieldnames" :key="index" :value="field.code">{{ field.code }}</option>
      </select>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    field: {
      type: Object
    },
    updated: {
      type: Function
    }
  },
  provide () {
    return {
      $validator: this.$validator
    }
  },
  name: 'CustomFieldItem',
  data () {
    return {
      name: '',
      type: 'text',
      code: 'name',
      value: true,
      fieldnames: [
        {
          name: 'Text',
          type: 'text',
          code: 'text',
          value: false
        },
        {
          name: 'Long text',
          type: 'longtext',
          code: 'longtext',
          value: false
        },
        {
          name: 'Phone Number',
          code: 'phone',
          type: 'phone',
          value: false
        },
        {
          name: 'Email',
          code: 'email',
          type: 'email',
          value: true
        },
        {
          name: 'Url',
          code: 'url',
          type: 'url',
          value: false
        },
        {
          name: 'Date',
          code: 'date',
          type: 'date',
          value: false
        }
      ]
    }
  },
  mounted () {
    if (this.field) {
      this.setData()
    }
  },
  methods: {
    setData () {
      const { name, type, code, value } = JSON.parse(JSON.stringify(this.field))
      this.name = name
      this.type = type
      this.code = code
      this.value = value
    },
    getInputState () {
      return {
        name: this.name,
        type: this.type,
        code: this.code,
        value: this.value
      }
    }
  },
  watch: {
    value () {
      this.updated('fieldList')
    },
    name () {
      this.updated('fieldList')
    },
    code () {
      console.log('code', this.code)
      const field = this.fieldnames.filter(field => field.code === this.code)
      if (field.length > 0) {
        this.type = field[0].type
      }
      this.updated('fieldList')
    }
  }
}
</script>

<style scoped>

</style>
